module.exports = __webpack_public_path__ + "static/media/instagram.2d3dba2d.svg";